import axios from 'axios';

export default {
    async login(username, password) {
        return await axios.post('/login',
            `username=${username}&password=${password}`,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then((response) => response)
            .catch((error) => error.response);
    },

    async logout() {
        return await axios.post('/logout',
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then((response) => response);
    },

    async getLoggedInUser() {
        return axios.get('/users/loggedIn');
    },

    async checkIsLoggedIn() {
        return axios.get('/users/isLoggedIn');
    },

    async getUsers() {
        return axios.get('/users');
    },

    async getUserById(userId) {
        return axios.get('/users/' + userId);
    },

    async getUserTeams(userId) {
        return axios.get('/users/' + userId + '/teams');
    },

    async updateUser(userId, user) {
        return axios.put('/users/' + userId,
            user,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async activateUser(userId) {
        return axios.patch(`/users/${userId}/activate`);
    },

    async deactivateUser(userId) {
        return axios.patch(`/users/${userId}/deactivate`);
    },

    async updateUserTeams(userId, teams) {
        return axios.put('/users/update-teams',
            {userId, teams},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async changePassword(resource) {
        return axios.post('/users/change-password',
            resource,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async resetPassword(resource) {
        return axios.post('/users/reset-password',
            resource,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async createUser(resource) {
        return axios.post('/users',
            resource,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },
}
